import { persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface ICurrentLenderCompany {
  lenderCompanyId: number | null;
  setCurrentLenderCompany: (lenderCompanyId: number) => void;
}

const initialState: Pick<ICurrentLenderCompany, "lenderCompanyId"> = {
  lenderCompanyId: null,
} as const;

export const useCurrentLenderCompanyStore =
  createWithEqualityFn<ICurrentLenderCompany>()(
    persist<ICurrentLenderCompany>(
      (set) => ({
        ...initialState,
        setCurrentLenderCompany: (lenderCompanyId: number) =>
          set({ lenderCompanyId }),
      }),
      {
        name: "current-lender-company",
      },
    ),
    shallow,
  );
